import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

const getItems = ({ commit }, { page = 'account_settlement_continuations', params = {} }) => {
  commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_TOGGLE_LOADING)

  fetch(page, { params })
    .then((response) => response.json())
    .then((data) => {
      commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_TOGGLE_LOADING)
      commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_SET_ITEMS, data.member)
      commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_SET_VIEW, data.view)
    })
    .catch((e) => {
      commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_TOGGLE_LOADING)
      commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_RESET)
}

export default getItems
